window.TmxConfiguratorCart=class {
  constructor({root,request=window.fetch.bind(window),storage=window.sessionStorage}) {
    this.root=new URL(root,window.location.origin);
    if(this.root.origin!==window.location.origin||!this.root.pathname.endsWith('/'))throw new Error('Invalid cart root');
    this.request=request;this.storage=storage;this.storageKey='tmx-pending-configurator-v1';
  }
  async json(path,body) {
    const abort=new AbortController(),timer=setTimeout(()=>abort.abort(),20000);
    try {
      const response=await this.request(new URL(path,this.root).href,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'}:{})},...(body?{body:JSON.stringify(body)}:{}),signal:abort.signal});
      const data=await response.json();
      if(!response.ok||data.status>=400)throw Object.assign(new Error('Cart request failed'),{status:response.status,description:data.description||data.message});
      return data;
    } finally { clearTimeout(timer); }
  }
  validQuantity(item) {
    const {minimum=1,increment=1,maximum=null}=item;
    return Number.isSafeInteger(item.quantity)&&item.quantity>=minimum&&(item.quantity-minimum)%increment===0&&(!Number.isInteger(maximum)||item.quantity<=maximum);
  }
  async preflight(plan) {
    const personalization=plan.personalization||{};
    const allowedProperties=['Принт','Print','Идея или линк','Idea or link','Гранитогресна плоча','Porcelain tile'];
    if(typeof personalization!=='object'||personalization===null||Array.isArray(personalization)||Object.keys(personalization).length>2||Object.entries(personalization).some(([key,value])=>!allowedProperties.includes(key)||typeof value!=='string'||value.length>2000))throw new Error('Invalid print personalization');
    if(!plan.items.length||plan.items[0].role!=='radiator'||plan.items.filter(item=>item.role==='radiator').length!==1||new Set(plan.items.map(item=>item.id)).size!==plan.items.length||plan.items.some(item=>!/^\d+$/.test(item.id)||!item.handle||!this.validQuantity(item)))throw new Error('Invalid configuration plan');
    const products=await Promise.all([...new Set(plan.items.map(item=>item.handle))].map(async handle=>[handle,await this.json('products/'+encodeURIComponent(handle)+'.js')]));
    const byHandle=new Map(products),fresh=[];
    for(const item of plan.items) {
      const variant=byHandle.get(item.handle).variants?.find(v=>String(v.id)===item.id);
      if(!variant||!Number.isSafeInteger(variant.price)||variant.price<0)throw new Error('Missing storefront variant');
      fresh.push({id:item.id,price:variant.price,available:variant.available===true});
    }
    return {fresh,changed:fresh.some((variant,i)=>variant.price!==plan.items[i].price||!variant.available)};
  }
  pending() {
    const saved=this.storage.getItem(this.storageKey);
    return saved?JSON.parse(saved):null;
  }
  inspect(cart,pending) {
    const lines=cart.items.filter(line=>line.properties?._tmx_configuration===pending.group);
    if(!lines.length)return 'empty';
    if(lines.length!==pending.items.length)return 'partial';
    const parent=lines.find(line=>line.properties._tmx_role==='radiator');
    if(!parent?.key)return 'partial';
    return pending.items.every(item=>{
      const matches=lines.filter(line=>String(line.variant_id||line.id)===item.id&&line.properties._tmx_role===item.role);
      return matches.length===1&&matches[0].quantity===item.quantity&&Object.entries(item.personalization||{}).every(([key,value])=>matches[0].properties?.[key]===value)&&(item.role==='radiator'?!matches[0].parent_relationship:matches[0].parent_relationship?.parent_key===parent.key);
    })?'complete':'partial';
  }
  async reconcile(pending) {
    try {
      const cart=await this.json('cart.js'),kind=this.inspect(cart,pending);
      if(kind==='complete'||kind==='empty')this.storage.removeItem(this.storageKey);
      return {kind,cart,group:pending.group};
    } catch { return {kind:'unknown',group:pending.group}; }
  }
  async checkPending() {
    try { const pending=this.pending();return pending?await this.reconcile(pending):{kind:'empty'}; }
    catch { return {kind:'unknown'}; }
  }
  async add(plan) {
    if(this.busy||window.TmxConfiguratorCart.active)return {kind:'busy'};
    this.busy=true;window.TmxConfiguratorCart.active=true;
    let pending;
    try {
      if(this.pending())return await this.checkPending();
      const preflight=await this.preflight(plan);
      if(preflight.changed)return {kind:'changed',fresh:preflight.fresh};
      pending={group:crypto.randomUUID(),items:plan.items.map(({id,role,quantity})=>({id,role,quantity,...(role==='radiator'&&plan.personalization?{personalization:plan.personalization}:{})}))};
      this.storage.setItem(this.storageKey,JSON.stringify(pending));
      const properties=role=>({_tmx_configuration:pending.group,_tmx_role:role,...(role==='radiator'?{[plan.modeLabel]:plan.mode,...(plan.personalization||{})}:{})});
      const first=plan.items[0];
      const parentResponse=await this.json('cart/add.js',{items:[{id:first.id,quantity:first.quantity,properties:properties('radiator')}],...(plan.items.length===1&&plan.sections.length?{sections:plan.sections,sections_url:plan.sectionsUrl}:{})});
      const parent=parentResponse.items?.find(line=>String(line.variant_id||line.id)===first.id&&line.properties?._tmx_configuration===pending.group);
      if(!parent?.key)throw new Error('Parent line was not returned');
      const response=plan.items.length===1?parentResponse:await this.json('cart/add.js',{items:plan.items.slice(1).map(item=>({id:item.id,quantity:item.quantity,parent_line_key:parent.key,properties:properties(item.role)})),...(plan.sections.length?{sections:plan.sections,sections_url:plan.sectionsUrl}:{})});
      const result=await this.reconcile(pending);
      return {...result,response};
    } catch(error) {
      if(pending)return {...await this.reconcile(pending),error:error.description||null};
      return {kind:'error',error:error.description||null};
    } finally { this.busy=false;window.TmxConfiguratorCart.active=false; }
  }
};
